<template>
	<v-form ref="form">
		<div class="resumo">
			<div class="resumo-title">Resumo do acordo</div>
			<div class="resumo-conteudo">
				<div class="resumo-item">
					<span class="titulo">Cadastro do Acordo:</span>
					<p>
						Periodo de
						<strong>{{ formatarMes(value.mesInicial) }}</strong> até
						<strong>{{ formatarMes(value.mesFinal) }}</strong>
					</p>
					<p>
						Espaço: <strong>{{ espacoPadrao }}</strong>
					</p>
					<p>
						Bandeira:
						<strong>{{ bandeira }}</strong>
					</p>
				</div>
				<v-divider />
				<div class="resumo-item">
                    <span class="titulo">Seleção de Filiais:</span>
                    <p>
                        Fornecedor:
                        <strong>{{ value.fornecedor }}</strong>
                    </p>
										<p>
												Filiais:
												<strong>
													<template v-if="Array.isArray(value.filiais)">
														{{ value.filiais.length }} selecionadas
													</template>
													<template v-else-if="typeof value.filiais === 'number'">
														{{ value.filiais }} selecionadas
													</template>
													<template v-else>
														0 selecionadas
													</template>
												</strong>
										</p>
                </div>
                <v-divider />
                <div class="resumo-item">
                    <span class="titulo">Seleção de Produtos:</span>
                    <p>
                        Fornecedor: <strong>{{ value.fornecedor }}</strong>
                    </p>
                    <p>
                        Produtos:
                        <strong>{{ produtosQuantidade}} selecionados</strong>
                    </p>
                </div>
                <div class="resumo-item resumo-total">
                    <p>
                        Total de investimento do acordo:
                        <span style="color: var(--v-primary-base)">
                            <formataReal :valor="investimento" />
                        </span>
                    </p>
                </div>
            </div>
        </div>
		<v-overlay
			:value="semAcesso"
			:absolute="true"
			:opacity="0.1"
			:z-index="3"
		></v-overlay>
	</v-form>
</template>
<script>
export default {
	props: ['value'],
	inject: ['listaCampos'],
	components: {},
	async created() {
		var lista = await this.listaCampos
	},
	data() {
		return {
			resumo: {},
			menuProps: {
				bottom: true,
				offsetY: true,
				contentClass: 'select-outline',
				transition: 'slide-y-transition',
			},
			semAcesso: false,
		}
	},
	mounted() {},
	computed: {
		produtosQuantidade() {
			if (this.value.produtos){
				return this.value.produtos.length
			}
			return 0
		},
		investimento() {
			if (this.value.valores && this.value.valores.length > 0) {
				// Soma todos os investimentos das linhas, exceto a linha Total
				return this.value.valores
					.filter(v => v.mes !== 'Total')
					.reduce((acc, v) => {
						// Usa o campo investimentoValor se existir, senão tenta converter o campo investimento
						let val = 0;
						if (typeof v.investimentoValor === 'number') {
							val = v.investimentoValor;
						} else if (typeof v.investimento === 'number') {
							val = v.investimento;
						} else if (typeof v.investimento === 'string') {
							// Remove R$ e pontos/virgulas para converter
							val = parseFloat(String(v.investimento).replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;
						}
						return acc + val;
					}, 0);
			}
			return 0;
		},
		espacoPadrao() {
			// Lógica idêntica ao PDV
			if (this.value.id_espaco && this.listaCampos && this.listaCampos.espaco) {
				const espaco = this.listaCampos.espaco.find(
					(e) => e.value === this.value.id_espaco
				);
				if (espaco && !this.value.ponta_tematica) {
					return espaco.text;
				} else if (this.value.prateleira_nome) {
					return this.value.prateleira_nome;
				}
			}
			return 'Campanha Circuito';
		},
		bandeira() {
			if (Array.isArray(this.value.bandeira)) {
				return this.value.bandeira.join(', ')
			}
			if (typeof this.value.bandeira === 'string') {
				return this.value.bandeira
			}
			return ''
		},
	},
	methods: {
		setSemAcesso(semAcesso) {
			this.semAcesso = semAcesso
		},
		validate() {
			return this.$refs.form.validate()
		},
		resetValidation() {
			this.resumo = {}
			try {
				this.$refs.form.resetValidation()
			} catch (error) {
				// erro ignorado propositalmente
			}
		},
		formatarMes(mes) {
			return this.$moment(mes, 'YYYY-MM')
				.format('MMMM [de] YYYY')
				.capitalize()
		},
		formataMoeda(valor = 0) {
			return valor.toLocaleString('pt-BR', {
				style: 'currency',
				currency: 'BRL',
			})
		},
	},
}
</script>
<style lang="scss">
.resumo {
	.resumo-total {
		grid-column: span 6;
		text-align: center;
		font-size: 1rem;
		margin-top: 1rem;
	}
	.resumo-title {
		font-size: 1.1rem;
		background: var(--v-primary-base);
		text-align: center;
		padding: 10px;
		color: #fff;
		font-weight: 500;
		border-radius: 8px 8px 0 0;
	}
	.resumo-conteudo {
		display: grid;
		grid-template-columns: 1fr 20px 1fr 20px 1fr;
		grid-gap: 15px;
		align-items: center;
		padding: 20px;
		border-radius: 0 0 8px 8px;
		font-weight: 500;
		font-size: 0.8rem !important;
		color: #808080;
		border: 1px solid #ddd;
		p {
			margin: 0;
		}
		.resumo-item {
			width: 100%;
			height: 100%;
			padding: 10px 20px;
			border-radius: 8px;
			background: #eaeaea;
			display: flex;
			flex-direction: column;
			justify-content: center;
			.titulo {
				font-weight: bold;
				color: var(--v-primary-base);
			}
		}
	}
}
</style>